import { passThroughAxios } from './passThrough.axios'
import FileUploadApi from './FileUpload.api.js'

export default {
  async getManuals() {
    try {
      const response = await passThroughAxios.get('manuals')
      return response.data
    } catch (e) {
      if (e.response?.status === 404) return []
      return Promise.reject(e)
    }
  },
  async addManual(file, title, sortOrder) {
    const { token } = await FileUploadApi.uploadToStaging(file)
    const response = await passThroughAxios.post('admin/tools/manuals', {
      fileToken: token,
      title,
      sortOrder,
    })
    return response.data
  },
  async deleteManual(manualId) {
    await passThroughAxios.delete(`admin/tools/manuals/${manualId}`)
  },
}
